import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ClarityTracker = () => {
  const location = useLocation();
  let clarityProjectId: string | null = null;

  if (process.env.REACT_APP_ENVIRONMENT === "PROD") {
    switch (process.env.REACT_APP_FINANCEIRA) {
      case "generico":
        clarityProjectId = process.env.REACT_APP_CLARITY_GENERICO_ID!;
        break;
      case "bradesco":
        clarityProjectId = process.env.REACT_APP_CLARITY_BRADESCO_ID!;
        break;
      case "itau":
        clarityProjectId = process.env.REACT_APP_CLARITY_ITAU_ID!;
        break;
    }
  }

  useEffect(() => {
    if (clarityProjectId) {
      (function (c: any, l: Document, a: string, r: string, i: string, t?: HTMLScriptElement, y?: Node) {
        c[a] = c[a] || function () {
          (c[a].q = c[a].q || []).push(arguments);
        };
        t = l.createElement(r) as HTMLScriptElement;
        t.async = true;
        t.src = "https://www.clarity.ms/tag/" + i;
        y = l.getElementsByTagName(r)[0];
        y.parentNode!.insertBefore(t, y);
      })(window as any, document, "clarity", "script", clarityProjectId);
    }
  }, [clarityProjectId, location]);

  return null;
};

export default ClarityTracker;
